import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadCrumb = _resolveComponent("BreadCrumb")!
  const _component_ProfileContent = _resolveComponent("ProfileContent")!
  const _component_UpdatePassword = _resolveComponent("UpdatePassword")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BreadCrumb, { PageTitle: "Profile" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ProfileContent),
      _createVNode(_component_UpdatePassword)
    ])
  ], 64))
}